export default __webpack_public_path__ + "static/media/quiz_bg.652b00b3.png";